import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import CommonDrawer from "../common/CommonDrawer";
import "./CategoryAdmin.css"; // reuse same UI css
import { toast } from "react-toastify";

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";

function BikeModelAdmin() {
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);

  const [brand, setBrand] = useState(null);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [open, setOpen] = useState(false);

  /* ---------- LOAD DATA ---------- */
  const loadBrands = async () => {
    const res = await axiosInstance.get("brands/");
    setBrands(res.data);
  };

  const loadModels = async (brandId) => {
    if (!brandId) {
      setModels([]);
      return;
    }
    const res = await axiosInstance.get(`bike-models/?brand=${brandId}`);
    setModels(res.data);
  };

  useEffect(() => {
    loadBrands();
  }, []);

  useEffect(() => {
    loadModels(brand);
  }, [brand]);

  /* ---------- FORM ---------- */
  const resetForm = () => {
    setName("");
    setEditId(null);
    setOpen(false);
  };

  const saveModel = async () => {
    if (!name || !brand) {
      return toast.error("Brand and Model name required");
    }

    if (editId) {
      await axiosInstance.put(`bike-models/?id=${editId}`, {
        name,
        brand,
      });
    } else {
      await axiosInstance.post("bike-models/", {
        name,
        brand,
      });
    }

    resetForm();
    loadModels(brand);
  };

  const editModel = (m) => {
    setEditId(m.id);
    setName(m.name);
    setBrand(m.brand.id);
    setOpen(true);
  };

  const deleteModel = async (id) => {
    if (window.confirm("Delete model?")) {
      await axiosInstance.delete(`bike-models/?id=${id}`);
      loadModels(brand);
    }
  };

  return (
    <div className="category-admin">
      <div className="header">
        <h2>Bike Models</h2>

        <button
          className="primary-btn"
          onClick={() => {
            resetForm();
            setOpen(true);
          }}
        >
          + Add Model
        </button>
      </div>

<FormControl fullWidth size="small" sx={{ mb: 2, mt:2 }}>
  <InputLabel id="brand-filter-label">Brand</InputLabel>
  <Select
    labelId="brand-filter-label"
    value={brand}
    label="Brand"
    onChange={(e) => setBrand(e.target.value)}
  >
    <MenuItem value="">
      <em>Select Brand</em>
    </MenuItem>

    {brands.map((b) => (
      <MenuItem key={b.id} value={b.id}>
        {b.name}
      </MenuItem>
    ))}

    {!brands.length && (
      <MenuItem disabled>No brands available</MenuItem>
    )}
  </Select>
</FormControl>

      {/* TABLE */}
      <div className="table">
        <div className="table-head">
          <span>Model Name</span>
          <span>Actions</span>
        </div>

        {models.map((m) => (
          <div className="table-row" key={m.id}>
            <span className="name">{m.name}</span>
            <div className="actions">
              <button className="edit" onClick={() => editModel(m)}>
                Edit
              </button>
              <button
                className="danger"
                onClick={() => deleteModel(m.id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}

        {!models.length && brand && (
          <div className="table-row">
            <span>No models found</span>
          </div>
        )}
      </div>

      {/* DRAWER */}
      <CommonDrawer
        open={open}
        title={editId ? "Edit Bike Model" : "Add Bike Model"}
        onClose={resetForm}
      >
<FormControl fullWidth size="small" sx={{ mb: 2,mt:2 }}>
  <InputLabel id="brand-drawer-label">Brand</InputLabel>

  <Select
    labelId="brand-drawer-label"
    value={brand ?? ""}
    label="Brand"
    onChange={(e) =>
      setBrand(e.target.value === "" ? null : Number(e.target.value))
    }
    MenuProps={{
      disablePortal: true,   // 🔥 IMPORTANT FIX
    }}
  >
    <MenuItem value="">
      <em>Select Brand</em>
    </MenuItem>

    {brands.map((b) => (
      <MenuItem key={b.id} value={b.id}>
        {b.name}
      </MenuItem>
    ))}
  </Select>
</FormControl>

        <input
          className="input"
          placeholder="Model name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <button className="primary-btn full" onClick={saveModel}>
          {editId ? "Update" : "Save"}
        </button>
      </CommonDrawer>
    </div>
  );
}

export default BikeModelAdmin;
